module.exports = "<ui-view></ui-view>"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/version/version.html
// module id = 784
// module chunks = 0